<template>
    <div>
        <div class="layout-right bg mb16">
            <Form :label-width="110">
                <Row :gutter="24">
                    <Col span="8">
                        <Form-item label="保单号">
                            <Input v-model.trim="params.policyNo" clearable placeholder="请输入保单号" @on-enter="tabChange"></Input>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="保单状态">
                            <Select v-model="params.status" clearable>
                                <Option value="1">待生效</Option>
                                <Option value="2">保障中</Option>
                                <Option value="3">已失效</Option>
                            </Select>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="结算状态">
                            <Select v-model="params.settlementStatus" clearable>
                                <Option value="1">未结算</Option>
                                <Option value="2">待审核</Option>
                                <Option value="3">已结算</Option>
                            </Select>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="发票状态">    
                            <Select v-model="params.invoiceStatus" clearable>
                                <Option value="1">未上传</Option>
                                <Option value="2">已上传</Option>
                            </Select>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="保障期限">
                            <daterange @on-change="val=>{setDateRange(val,'insuranceDate')}" placeholder="请选择保障期限" placement="bottom-end"></daterange>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="保单创建时间">
                            <daterange @on-change="val=>{setDateRange(val,'createTime')}" isFulltime placeholder="请选择创建时间" placement="bottom-end"></daterange>
                        </Form-item>
                    </Col>
                </Row>
                <Row>
                    <Col span="12" class="left">
                        <Button type="primary" :disabled="selectedRows.length === 0" @click="openBatchSettle">批量结算</Button>
                    </Col>
                    <Col span="12" class="right">
                        <Button type="primary" @click="tabChange">搜索</Button>
                        <Button type="primary" @click="exportToExcel('/casual/policy/list/export',params)">导出</Button>
                    </Col>
                </Row>
            </Form>
        </div>
        <div class="layout-right bg">
            <i-table :columns="columns" url="/casual/policy/list.json" :params="params" ref="table" :selection="true" selectType="settlement" @on-selection-change="onSelectionChange">
                <template slot-scope="{ row }" slot="action">
                    <Dropdown transfer>
                        <a href="javascript:void(0)">
                            管理
                            <Icon type="ios-arrow-down"></Icon>
                        </a>
                        <Dropdown-menu slot="list">
                            <Dropdown-item @click.native="toDetail(row)" style="text-align: center;">
                                <a>查看详情</a>
                            </Dropdown-item>
                            <Dropdown-item v-if="row.settlementStatus=='1'" @click.native="openSettle(row)" style="text-align: center;">
                                <a>结算</a>
                            </Dropdown-item>
                        </Dropdown-menu>
                    </Dropdown>
                </template>
            </i-table>
        </div>
        <!-- 结算上传 -->
        <Modal v-model="settleShow" :title="isBatchSettle ? '批量结算' : '结算'" :mask-closable="false" width="520">
            <Form :label-width="110">
                <Form-item label="上传付款凭证：">
                    <UploadFileImg
                        type="select"
                        :accept="['image','pdf','zip']"
                        :onlyFile="true"
                        btn-text="上传"
                        @on-success="uploadSettleSuccess"
                    />
                    <a v-if="settleForm.attachmentUrl" :href="settleForm.attachmentUrl" target="_blank" rel="opener" class="ml15">查看</a>
                    <p class="mt10" style="color:#999;">格式为图片、pdf、压缩包，仅支持上传1个文件</p>
                </Form-item>
            </Form>
            <div slot="footer">
                <Button @click="settleCancel">取消</Button>
                <Button type="primary" :disabled="!settleForm.attachmentUrl || submitLoading" :loading="submitLoading" @click="confirmSettle">提交</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
    import ITable from '@/components/common/ITable'
    import daterange from '@/components/common/daterange'
    import UploadFileImg from '@/components/common/UploadFileImg'
    export default {
        name:'policyTPL',
        components:{ ITable,daterange,UploadFileImg },
        data () {
            return {
                loading: false,
                submitLoading: false,
                settleShow:false,
                settleForm:{},
                isBatchSettle: false,
                selectedRows: [],
                selectedPolicies: [],
                params: {},
                columns: [
                    {type: 'selection',width: 60,align: 'center',fixed: 'left'},
                    {title:'保单号',key:'policyNo',width: 260,fixed: 'left'},
                    {title:'险种',key:'insuranceName',minWidth: 180,ellipsis: true,tooltip: true},
                    {title:'保障方案',key:'insurancePlanName',minWidth: 180,ellipsis: true,tooltip: true},
                    {title:'保费（元）',key:'premium',width: 120,align: 'right'},
                    {title:'保障起期',key:'beginDate',width: 120},
                    {title:'保障止期',key:'endDate',width: 120},
                    {title:'保单创建时间',key:'createTime',width: 180},
                    {title:'状态',key:'statusName',width: 120},
                    {title:'结算状态',key:'settlementStatusName',minWidth: 160},
                    {title:'发票状态',key:'invoiceStatusName',minWidth: 160},
                    {
                        title: '操作',
                        slot: 'action',
                        width: 90,
                        fixed: 'right'
                    }
                ]
            }
        },
        computed:{
        },
        created () {
            // this.getList()
        },
        methods:{
            setDateRange (val,key) {
                this.params[key+"Begin"] = val[0];
                this.params[key+"End"] = val[1];
            },
            tabChange(){
                this.$refs.table.getList()
            },
            toDetail(row){
                this.$router.push({
                    path:`/my/customizedLineWork/policyDetail/${row.policyNo}`
                })
            },
            openSettle(row){
                this.isBatchSettle = false
                this.settleForm = {
                    policyNo: row.policyNo,
                    attachmentUrl: ''
                }
                this.settleShow = true
            },
            openBatchSettle(){
                if(this.selectedRows.length === 0){
                    this.alert('请先选择要结算的保单')
                    return
                }
                this.isBatchSettle = true
                this.selectedPolicies = [...this.selectedRows]
                this.settleForm = {
                    attachmentUrl: ''
                }
                this.settleShow = true
            },
            onSelectionChange(selection){
                this.selectedRows = selection
            },
            uploadSettleSuccess(val){
                this.settleForm.attachmentUrl = val.url
            },
            settleCancel(){
                this.settleShow = false
                this.settleForm = {}
                this.selectedRows = []
                this.selectedPolicies = []
                this.submitLoading = false
            },
            async confirmSettle(){
                // 防止重复点击
                if(this.submitLoading) return
                
                const { attachmentUrl } = this.settleForm
                if(!attachmentUrl) return this.alert('请先上传付款凭证')
                
                this.submitLoading = true
                
                try {
                    let policyNos = []
                    if(this.isBatchSettle){
                        // 批量结算
                        policyNos = this.selectedPolicies.map(policy => policy.policyNo)
                    } else {
                        // 单个结算
                        policyNos = [this.settleForm.policyNo]
                    }
                    // 提交结算凭证
                    await this.$axios.post('/casual/policy/settlement/submit.json',{
                        policyNos,
                        attachmentUrl
                    })
                    this.toast(this.isBatchSettle ? '批量结算提交成功' : '提交成功')
                    this.settleCancel();
                    this.$refs.table.getList()
                } catch (error) {
                    console.error('提交失败:', error)
                } finally {
                    this.submitLoading = false
                }
            }
        }
    }
</script>
<style lang="less" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customizedLineWork/policy/index.vue